import { Component } from 'react';
import PropTypes from 'prop-types';

class App extends Component {
  componentWillMount() {
    const STX_APP = window.secutix.__APP__;
    const { config, user, cart } = STX_APP;

    const { languages = [], continueShoppingURL = '/', currencyCode = '' } = config;

    if (!this.props.isEvolutionTheme) {
      const SecuTixAPI = {
        getCart() {
          const { totalItems: nbItems = 0, totalAmount: amount = 0 } = cart;
          return { nbItems, amount: parseFloat(amount).toFixed(2), currency: currencyCode };
        },
        getContact() {
          if (user) {
            return { ...user, lang: user.lang };
          }
          return {};
        },
        getUrls() {
          const langs = languages.reduce(
            (obj, key) => ({
              ...obj,
              [key]: `?lang=${key}`,
            }),
            {},
          );

          return {
            account: '/account',
            cart: '/cart/shoppingCart',
            continueShopping: continueShoppingURL,
            logout: '/account/logout',
            langs,
          };
        },
        toggleSecutixMobileMenu: () => {
          this.props.toggleMobileMenu();
        },
      };
      window.SecuTixAPI = SecuTixAPI;
    }
  }

  render() {
    return null;
  }
}

App.propTypes = {
  toggleMobileMenu: PropTypes.func.isRequired,
  isEvolutionTheme: PropTypes.bool,
};

App.defaultProps = {
  isEvolutionTheme: false,
};

export default App;
